export default function raf(tick, fps = 1000 / 60) {
	let frame;
	const interval = setInterval(() => (frame = requestAnimationFrame(tick)), fps);

	return () => {
		clearInterval(interval);
		cancelAnimationFrame(frame);
	};
}
